const initialState = 0;

const ReservationDocStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationDocStatus":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationDocStatusReducer;
